import { compose } from 'recompose';
import ClickOutside from 'react-click-outside';

import DropDown from './DropDown';

const enhance = compose(ClickOutside);

export default enhance(DropDown);
